import React from 'react';
import { formErrorTextPropTypes } from './FormErrorTextPropTypes';
const FormErrorText = ({
  classname,
  text
}) => /*#__PURE__*/React.createElement("p", {
  className: classname || ''
}, text);
export default FormErrorText;